<template>
    <div class="loginCon dialog-con">
        <div class="dialog-con-bg"></div>
        <div class="dialog-warp loginWrap clearfix">
            <div class="content-box">
                <div class="login-head">
                    <div class="label f18 fwb-600">验证码登录</div>
                </div>
                <div class="login-form">
                    <el-form :modelValue="formData">
                        <el-form-item name="phone" required>
                            <el-input placeholder-style="color:#999;font-size:16px" v-model="formData.account"
                                placeholder="手机号" onkeyup="this.value=this.value.replace(/\D/g,'')" />
                        </el-form-item>
                        <el-form-item name="code" required>
                            <el-input placeholder-style="color:#999;font-size:16px" :clearable="false"
                                v-model="formData.code" placeholder="验证码"
                                onkeyup="this.value=this.value.replace(/\D/g,'')" />
                            <div class="sms-btn" @click="!sms.disabled?send():''">
                                {{ !sms.disabled?'发送验证码':`重新发送  (${sms.count}s)` }}</div>
                        </el-form-item>
                    </el-form>
                    <div class="logion-error" v-if="showError">
                        {{ errorText }}
                    </div>
                    <div class="login-agreement f14 flexible aItem-center">
                        <img v-if="!isCheck" src="@/assets/login/ic_no.png" class="ic_no mr5" @click="check" />
                        <img v-if="isCheck" src="@/assets/login/ic_yes.png" class="ic_no mr5" @click="check" />
                        <div>我已阅读并同意</div>
                        <div class="active">
                            <router-Link :to="'/userAgree'" target="_blank">《用户协议》</router-Link>
                        </div>
                        <div class="active">
                            <router-Link :to="'/privacy'" target="_blank">《隐私协议》</router-Link>
                        </div>
                    </div>
                    <div class="login-btn" @click="gotoLogin()">登录/注册</div>
                </div>
            </div>

        </div>
        <div class="dialog-close" @click="closelogin()">
            <img src="../../assets/login/ic_close.png" />
        </div>
    </div>
</template>

<script>
    import {
        login,
        logout,
        authrefreshToken,
        usercaptcha
    } from "@/api/login";
    import {
        hideLoading,
        showLoading
    } from "@/utils/load";
    export default {

        data() {
            return {
                /* 登录信息 */
                formData: {
                    account: '',
                    code: '',
                },
                /* 验证码 */
                sms: {
                    disabled: false,
                    total: 60,
                    count: 0
                },
                /* 是否同意协议 */
                isCheck: false,
                /* error信息 */
                showError: false,
                errorText: ""

                /*facebook*/
                // fbSignInParams: {
                //     scope: 'email,user_likes',
                //     return_scopes: true
                // },
                // /*google*/
                // googleSignInParams:{
                //     // client_id: '1091104845468-dkcluvl364g1aak2c046th3mol5k9d4j.apps.googleusercontent.com'
                //     client_id: '275356979130-0oupu9o675uh92jcl2tief8iv4r7qq6v.apps.googleusercontent.com'
                // },
                // loginType: null,
                // googleToken: '',
                // fbParams: {},
                // envType: '',
                // emailForm: {
                //     account: '115076891@qq.com',
                //     password: '123123'
                // }
            };
        },
        created() {},
        methods: {
            //勾选协议
            check() {
                this.isCheck = !this.isCheck;
            },
            timerHandler() {
                this.sms.count = this.sms.total
                this.sms.disabled = true
                let timer
                if (timer) clearInterval(timer)

                timer = setInterval(() => {
                    if (this.sms.count > 1 && this.sms.count <= this.sms.total) {
                        this.sms.count--
                    } else {
                        this.sms.disabled = false
                        clearInterval(timer)
                    }
                }, 1000)
            },
            // 监听回车键执行事件
            keyDown(e) {
                // 回车则执行登录方法 enter键的ASCII是13
                if (e.keyCode === 13) {
                    this.gotoLogin() // 需要执行的方法方法
                }
            },
            // 登录
            gotoLogin() {
                if (!this.formData.account) {
                    this.showError = true;
                    this.errorText = '请输入正确的手机号';
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                    return true
                }
                if (!this.formData.code) {
                    this.showError = true;
                    this.errorText = '请输入正确的验证码';
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                    return true
                }
                if (!this.isCheck) {
                    this.showError = true;
                    this.errorText = '请勾选隐私协议';
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                    return true
                }
                if (this.formData.account && this.formData.code) {
                    showLoading()
                    this.$store.dispatch('Login', this.formData).then((res) => {
                            if (res.success) {
                                // console.log(this.$route)
                                this.$router.replace(this.$route.fullPath || '/')
                                // this.$router.replace('/')
                                location.reload()
                                this.closelogin()
                                this.$success('custom', '登录成功')
                                // this.$emit('getHeader')
                            }
                        })
                        .catch(() => {
                            hideLoading()
                        })
                }

            },
            // 获取短信验证码
            send() {
                if (!this.formData.account) {
                    this.showError = true;
                    this.errorText = '请输入正确的手机号';
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                    return true
                }
                let item = {
                    mobile: this.formData.account,
                }
                usercaptcha(item).then(res => {
                    // console.log(res)
                    if (res.code == 1) {
                        this.timerHandler()
                        // console.log(res)
                    }
                });
            },

            // // 登录框关闭
            closelogin() {
                this.$emit('changeLogin', false)
            },
        },
        mounted() {
            window.addEventListener('keydown', this.keyDown)
        },
        // 销毁事件
        destroyed() {
            window.removeEventListener('keydown', this.keyDown, false)
        }

    };
</script>
<style lang="scss" scoped>
    .loginWrap {
        width: 421px;
        height: 512px;
        background: url("../../assets/login/login_bg.png") no-repeat;
        background-size: 421px 512px;

        .content-box {
            padding: 112px 40px 0;

            .login-head {
                width: 100%;
                // height: 398px;
                position: relative;

                .label {
                    width: 100%;
                    text-align: left;
                }
            }

            .login-form {
                margin-top: 36px;

                /deep/.el-input__inner {
                    height: 52px;
                    background: #F5F5F5;
                    border-radius: 3px;
                    border: none;
                    color: #333;
                    font-size: 16px;
                }

                /deep/.el-form-item {
                    margin-bottom: 30px;
                }

                .sms-btn {
                    position: absolute;
                    right: 20px;
                    top: 6px;
                    font-size: 14px;
                    color: #F68A01;
                    font-weight: 400;
                    cursor: pointer;
                }
            }

        }

        .logion-error {
            width: 244px;
            height: 54px;
            background: rgba(0, 0, 0, 0.59);
            border-radius: 3px;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 54px;
            text-align: center;
            position: absolute;
            top: 326px;
            left: 88px;

        }

        .login-btn {
            width: 100%;
            height: 46px;
            background: #F68A01;
            border-radius: 49px;
            font-size: 18px;
            font-weight: 600;
            color: #fff;
            line-height: 48px;
            text-align: center;
            margin-top: 15px;
            cursor: pointer;
        }

        .login-agreement {
            color: #999;
            margin-top: 76px;

            .ic_no {
                display: block;
                width: 16px;
                height: 16px;
            }

            .active {
                a {
                    color: #567598;
                }

            }
        }



    }
</style>